import { Box, IconButton, Link, Typography } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';



import type { ProcessingStep } from './types';

type Props = {
    isBulkView: boolean;
    spLotIds: string[];
    processingSteps: ProcessingStep[];
    handleBackNavigation: () => void;
    setSpLotsDialogOpen: (v: boolean) => void;
    classes?: any;
}

const ProcessingHeader = ({ isBulkView, spLotIds, processingSteps, handleBackNavigation, setSpLotsDialogOpen, classes }: Props) => {
    return (
        <Box sx={{
            width: '100%',
            minHeight: 116,
            height: 'auto',
            background: '#058333',
            color: 'white',
            padding: '16px 18px',
            gap: '10px',
            opacity: 1
        }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 1.5
            }}>
                <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                        <IconButton
                            size="small"
                            onClick={handleBackNavigation}
                            sx={{
                                color: '#FFFFFF',
                                p: 0,
                                '&:hover': { backgroundColor: 'transparent' }
                            }}
                        >
                            <KeyboardArrowLeftIcon sx={{ width: 33.6, height: 33.6, stroke: '#FFFFFF', strokeWidth: 0.6 }} />
                        </IconButton>
                        <Typography sx={{ ml: '8px', fontSize: '23.4px', fontWeight: 500 }} variant="body2">
                            {isBulkView ? 'SP Lot Bulk' : 'SP Lot'}
                        </Typography>
                    </Box>
                    {!isBulkView ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: '46px' }}>
                            <img src="icons/vector_icon.png" alt="SP Lot" style={{ width: 20.4, height: 20.4, display: 'block' }} />
                            <Typography variant="body1" className={classes?.labelNoto14Bold400_hh}>
                                {spLotIds[0]}
                            </Typography>
                        </Box>
                    ) : (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: '46px'}}>
                            <img src="icons/vector_icon.png" alt="SP Lot" style={{ width: 20.4, height: 20.4, display: 'block'}} />
                            <Typography variant="body2" sx={{ fontSize: '1.1375rem', opacity: 0.9 }}>
                                SP Lots ({spLotIds.length}):
                            </Typography>
                            <Link
                                className={classes?.labelNoto14Bold400_hh}
                                href="#"
                                onClick={(e) => { e.preventDefault(); setSpLotsDialogOpen(true); }}
                                sx={{ color: 'white', textDecoration: 'underline', '&:hover': { opacity: 0.9 } }}
                            >
                                View All SP Lots
                            </Link>
                        </Box>
                    )}
                </Box>
                <Box sx={{ textAlign: 'right' }}>
                    <Typography variant="body2" color="#FFFFFF" className={classes?.labelNoto12Bold400_hh} sx={{ opacity: 0.9 }}>
                        Progress
                    </Typography>
                    <Typography variant="h6" sx={{ mt: 0.5, fontSize: '31.2px', fontWeight: 400 }}>
                        {isBulkView ? '1/1' : `${processingSteps.filter(s => s.status === 'Completed' || s.status === 'Skipped').length}/${processingSteps.length}`}
                    </Typography>
                </Box>
            </Box>
            <Box sx={{
                width: '100%',
                height: '6px',
                backgroundColor: 'rgba(255, 255, 255, 0.3)',
                borderRadius: '3px',
                overflow: 'hidden'
            }}>
                <Box sx={{
                    width: isBulkView ? '100%' : `${processingSteps.length > 0 ? (processingSteps.filter(s => s.status === 'Completed' || s.status === 'Skipped').length / processingSteps.length) * 100 : 0}%`,
                    height: '100%',
                    backgroundColor: 'white',
                    borderRadius: '3px',
                    transition: 'width 0.3s ease'
                }} />
            </Box>
        </Box>
    );
}

export default ProcessingHeader;
